export const i18n_fi = {
    action: {
      search: 'Etsi',
      back: 'Takaisin',
      next: 'Seuraava',
      previous: 'Edellinen',
      mark_lessons: 'Kirjaa tunnit',
      mark_lesson: 'Kirjaa tunti',
      clear_search: 'Tyhjennä',
      click_to_confirm_remove: 'Vahvista poisto',
      save_changes: 'Tallenna muutokset',
      save_lesson: 'Tallenna tunti',
      new_lesson: 'Uusi tunti',
      import_file: 'Tuo',
      open_drivercard: 'Avaa kuljettajakortti',
      print_drivercard_pdf: 'Tulosta kuljettajakortti',
      print_drivercard_pdf_course: 'Tulosta kurssin kuljettajakortit',
    },
    app: {
      cancel: 'Peruuta',
      confirm_logout: 'Haluatko varmasti kirjautua ulos?',
      civil_driving_licenses: 'Ajokorttiluokat siviilissä',
      missing_perm: 'Tarkista käyttäjän oikeudet',
      description: 'Kuvaus',
      app_name: 'PVKULTU opetuksen seuranta',
      username: 'Käyttäjätunnus',
      password: 'Salasana',
      last_name: 'Sukunimi',
      name: 'Nimi',
      not_found: '404 Sivua ei löydy',
      login: 'Kirjaudu sisään',
      login_failed: 'Kirjautuminen epäonnistui. Tarkista tunnukset.',
      logout: 'Kirjaudu ulos',
      react_error: 'Virhe toimintoa suoritettaessa',
      lessons_booking: 'Tuntien kirjaaminen',
      lessons_status: 'Opetuksen tilanne',
      lessons_edit: 'Oppitunnit',
      theory_lessons: 'Teoriatunnit',
      theory_lessons_booking: 'Teoriatuntien kirjaus',
      training_lessons: 'Harjoittelutunnit',
      training_lessons_booking: 'Harjoittelun kirjaus',
      trafi_id: 'Trafi Id',
      driving_lessons: 'Ajotunnit',
      driving_lessons_booking: 'Ajotuntien kirjaus',
      select_unit: 'Joukko-osasto',
      yes: 'Kyllä',
      previous_entries: 'Aiempia suorituksia',
      entries: 'Suorituksia',
      undones: 'Rästejä',
      edit_theorylesson_entry: 'Muokkaa teoriatunnin kirjausta',
      edit_traininglesson_entry: 'Muokkaa harjoittelun kirjausta',
      edit_drivinglesson_entry: 'Muokkaa ajotunnin kirjausta',
      supervisor: 'Valvoja',
      lesson_completed: 'Tunti suoritettu',
      remove_lesson_entry: 'Poista kirjaus',
      previous_undone: 'Rästejä',
      previous_complete: 'Suorituksia',
      pro_theory: 'Ammattiteoria',
      pro_driving: 'Ammattiajo',
      theory: 'Teoria',
      driving: 'Ajo',
      training: 'Harjoittelu',
      lesson_status: 'Tila',
      active: 'Aktiivinen',
      completed: 'Suoritettu',
      failed: 'Hylätty',
      compensated: 'Hyväksiluettu',
      undone: 'Rästi',
      dropped_out: 'Keskeyttänyt',
      missing: 'Puuttuu',
      save: 'Tallenna',
      complete_undone_theorylesson: "Kirjaa teoriatunti",
      complete_undone_traininglesson: "Kirjaa harjoittelu",
      select: 'Valitse',
      study_overview: 'Opetuksen kokonaiskuva',
      data_import: 'Tuo tietoja'
    },
    search: {
      course_number: 'Kurssi',
      course_year: 'Vuosi',
      course_unit: 'Joukko-osasto',
      applicant_name: 'Henkilön nimi',
      applicant_status: 'Tila',
      team: 'Joukkue',
      exam_class: 'Luokka',
      lesson_type: 'Tyyppi',
      lesson_date: 'Tunti suoritettu',
      missing_lesson: 'Henkilöt, joilta puuttuu',
      select_missing_lesson: 'Valitse tunti...',
      lesson_type_all: 'Kaikki',
      lesson: 'Tunti',
      select_lesson_type: 'Valitse tyyppi...',
      show_only_undone: 'Näytä vain rästimerkinnät',
      theory_course_number: 'Kurssi',
      only_applicants_with_undone: 'Näytä vain ne, joilla on rästi',
      other_courses: 'Muut kurssit',
      include_active: "Aktiiviset",
      include_dropped: "Myös keskeyttäneet"
    },
    datatable: {
      independent_training: 'Ennen itsenäistä ajotehtävää',
      person_transport: 'Vaaditaan hlökuljetusoikeuteen',
      lesson_type: 'Tyyppi',
      exam_class: 'Luokka',
      topic: 'Aihe',
      completed: 'Suoritettu',
      compensated: 'Hyväksiluettu',
      undone: 'Rästissä',
      undone_entry: 'Rästimerkintä',
      lesson_description: 'Tunnin kuvaus',
      compulsory_lessons: 'Pakolliset',
      additional_lessons: 'Lisäopetus',
      course_lessons: 'Vain kurssiin liittyvät',
      course: 'Kurssi',
      additional_info: 'Lisätiedot',
      permission_status: 'Lupatilanne',
      permission_status_legend: 'Näytä/piilota selitteet',
    },
    message: {
      add_entries_failed: 'Kirjauksessa tapahtui virhe',
      add_entries_success: 'Tunnit kirjattu onnistuneesti!',
      check_date_form: 'Tarkista päivämäärä! Päivämäärän tulee olla muodossa pp.kk.vvvv',
      no_applicants_found: 'Kokelaita ei löytynyt',
      update_lesson_entry_error: 'Virhe tallennuksessa',
      remove_lesson_entry_error: 'Virhe kirjauksen poistossa',
      update_lesson_entry_success: 'Kirjaus päivitetty!',
      remove_lesson_entry_success: 'Kirjaus poistettu!',
      update_applicant_error: 'Virhe tietojen päivityksessä',
      update_applicant_success: 'Tiedot päivitetty',
      no_lessons_found: 'Tunteja ei löytynyt',
      import_data_success: 'Tiedosto "%{name}" tuotu järjestelmään onnistuneesti',
    },
    applicant: {
      active: 'Aktiivinen',
      passive: 'Keskeyttänyt',
      theory_lessons_completed: 'Teoriatunteja suoritettu',
      training_lessons_completed: 'Harjoittelutunteja suoritettu',
      pre_driving_lessons_completed: 'Ennen ajotehtävää vaadittuja suoritettu',
      driving_lessons_completed: 'Ajo-opetustunteja suoritettu',
      has_no_pro_perm: 'Ei voimassaolevaa ammattipätevyyttä',
      has_pro_perm: 'Voimassaoleva ammattipätevyys entuudestaan',
      independent_driving_lessons_badge: 'A',
      independent_driving_lessons_incomplete: 'Itsenäiseen ajoon vaadittu opetus kesken',
      independent_driving_lessons_completed: 'Itsenäiseen ajoon vaadittu opetus täyttyy',
      independent_driving_lessons_disabled: 'Muokattavissa vain KULTIssa',
      independent_handling_badge: 'K',
      independent_handling_eligible: 'Myönnä oikeus itsenäiseen käsittelyharjoitteluun',
      independent_handling_approved: 'Kykenee itsenäiseen käsittelyharjoitteluun',
      has_adr_perm: 'Voimassaoleva ADR-ajolupa',
      has_adr_perm_for_classes: 'ADR-ajolupa luokkiin',
      no_active_course: 'Ei aktiivista kurssia',
      applicant_passive: 'Kokelas keskeyttänyt kurssin',
      person_transport_perm_badge: 'H',
      person_transport_perm_approved: 'Henkilönkuljetusoikeus myönnetty',
      person_transport_perm_waiting_approval: 'Henkilönkuljetusoikeus lähetetty KULTIIN',
      person_transport_perm_kulti_approval_pending: "Odottaa esittelyä",
      person_transport_perm_kulti_approved: "Esitelty",
      person_transport_perm_eligible: 'Henkilönkuljetusoikeus lähetettävissä KULTIIN',
      person_transport_perm_not_eligible: 'Henkilönkuljetusoikeusopetus kesken',
      person_transport_perm_disabled_not_eligible: 'Henkilönkuljetusoikeusopetus kesken',
      person_transport_perm_disabled_not_teacher: 'Vain kouluttajalla on oikeus myöntää henkilönkuljetusoikeus',
      person_transport_perm_disabled_kulti_already_approved: "Henkilönkuljetusoikeus on jo esitelty",
    },
    driving_lesson: {
      driving_lesson_details: 'Täytä suoritetun ajotunnin tiedot',
      lesson_date: 'Tunti suoritettu',
      start_time: 'Alkoi',
      end_time: 'Loppui',
      beneficial_driving: 'Ajo oli hyötyajoa',
      class: 'Luokka',
      subject: 'Aihe',
      plate_number: 'Ajoneuvon rekisteritunnus',
      kilometrage: 'Ajotunnilla ajettu matka',
      additional_info: 'Tunnin lisätiedot',
      add_lesson_pause: 'Lisää aika',
      remove_lesson_pause: 'Poista',
      add_lesson: 'Lisää ajotunti',
      loading: 'Lastausaika',
      waiting: 'Odotusaika',
      other: 'Muu',
      lesson_pause_type: 'Odotus-, lastaus- tai purkuaika',
      add_new_driving_lesson: 'Lisää uusi ajotunti',
      pause_start_time: 'Alkoi',
      pause_end_time: 'Loppui',
      lessonTopics: 'Opetuskohteet',
      applicant_info_multiple: 'Valitut %{count} kokelasta'
    },
    edit_lesson: {
      description: 'Tunnin kuvaus',
      description_short: 'Lyhytnimi',
      topic: 'Aihe',
      exam_classes: 'Luokat',
      lesson_type: 'Tyyppi',
      independent_training: 'Ennen itsenäistä ajotehtävää',
      person_transport: 'Vaaditaan henkilönkuljetusoikeuteen',
      save_success: 'Tunti tallennettu onnistuneesti',
      save_failure: 'Tunnin tallentaminen epäonnistui: ',
      remove_success: 'Tunti poistettu onnistuneesti',
      remove_failure: 'Tunnin poistaminen epäonnistui: ',
      remove: 'Poista',
      remove_confirmation: 'Haluatko varmasti poistaa tunnin?',
      additional_lesson: 'Lisäopetustunti',
      order_number: 'Järjestysnumero'
    },
    dataimport: {
      pick_file: "Tiedosto",
      failure_xml: "Tiedoston sisältö puutteellinen",
      failure_type: "Tuntematon viestityyppi",
      failure: "Tiedoston lataus ei onnistunut",
    },
    driver_card: {
      title: "Kuljettajakortti",
      person: "Henkilö",
      trafi_id: "Trafi id",
      last_name: "Sukunimi",
      first_names: "Etunimet",
      civil_driving_licence: "Siviiliajokortti",
      course: "Kurssi",
      medical_certificate: "Lääkärinlausunto",
      current_medical_state: "Nykyinen terveydentila",
      current_medical_state_date: "Päivämäärä",
      driver_exam_information: "Kuljettajan tutkintotiedot",
      exam_class: "Tutkintoluokka",
      driving_exam_count: "Ajokoekerrat",
      theory_exam_count: "Teoriakoekerrat",
      driving_training: "Ajo-opetus",
      name: "Nimi",
      lesson_time: "Opetusaika",
      total: "Yht",
      independent_training: "Itsenäinen sovellutus",
      guided_training: "Ohjattu harjoittelu.",
      training: "Ajoharjoittelu",
      supervisor: "Opettaja",
      topic: "Opetuskohde",
    },
    course: {
      selected_course: "Käsiteltävä kurssi",
      no_selection: "Valitse kurssi",
      select: "Valitse",
      not_found: "Valittua kurssia ei löydy",
    }
};


// WEBPACK FOOTER //
// ./src/i18n_fi.js